import React from 'react';
import { Link } from 'react-router-dom';

const links = [
  { to: '/freelance-contract-belgium', label: 'Freelance Contract België', desc: 'Template voor Belgische freelancers en zelfstandigen' },
  { to: '/freelance-contract-netherlands', label: 'Freelance Contract Nederland', desc: 'Template voor Nederlandse ZZP\'ers' },
  { to: '/nda-template-belgium', label: 'NDA Template België', desc: 'Geheimhoudingsovereenkomst voor Belgische freelancers' },
  { to: '/nda-template-netherlands', label: 'NDA Template Nederland', desc: 'NDA voor Nederlandse ZZP\'ers en freelancers' },
];

const BeneluxInternalLinks = () => (
  <section className="mb-12">
    <h2 className="text-2xl font-bold text-[#2F4E6F] mb-6">Regionale contract templates</h2>
    <p className="text-gray-600 mb-6">Bekijk onze landspecifieke templates voor meer gerichte informatie:</p>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {links?.map((link, i) => (
        <Link
          key={i}
          to={link?.to}
          className="block p-5 border border-gray-200 rounded-xl bg-white hover:border-[#FF8C00] hover:shadow-md transition-all duration-200 group"
        >
          <div className="font-semibold text-[#2F4E6F] group-hover:text-[#FF8C00] transition-colors mb-1">{link?.label}</div>
          <div className="text-sm text-gray-500">{link?.desc}</div>
        </Link>
      ))}
    </div>
  </section>
);

export default BeneluxInternalLinks;
